import React from 'react';
import { string, shape, number } from 'prop-types';
import classNames from 'classnames/bind';
import { uniq } from 'ramda';
import { Link } from 'react-router-dom';

import { withCountryContext } from 'containers/withCountryContext';

import { ImagePlaceholder } from 'components/ImagePlaceholder';
import { ImageTechDoc } from 'components/ImageTechDoc';

import styles from './TopRefsItem.module.scss';

const cx = classNames.bind(styles);

const TopRefsItem = ({ data }) => {
  const brandsArr =
    data &&
    data.oenNumbers &&
    data.oenNumbers.array.map((item) => item.brandName);
  const productBrands = brandsArr && uniq(brandsArr).join('&nbsp;. ');

  return (
    <Link
      to={`/product/${data.directArticle.articleId}/about`}
      className={cx('item')}
    >
      <div className={cx('img')}>
        {data.articleThumbnails && data.articleThumbnails.array ? (
          <ImageTechDoc
            id={data.articleThumbnails.array[0].thumbDocId}
            alt={data.directArticle.articleName}
          />
        ) : (
          <ImagePlaceholder className={cx('placeholder-icon')} />
        )}
      </div>
      <section className={cx('info')}>
        <h3 className={cx('item-title')}>
          <span className={cx('title-text')}>
            {data.directArticle.articleName} {data.directArticle.articleAddName}
          </span>
        </h3>

        <div className={cx('reference')}>
          <span className={cx('ref-text')}>{data.directArticle.articleNo}</span>
        </div>
        <div
          className={cx('product-brands')}
          dangerouslySetInnerHTML={{ __html: productBrands }}
        />
      </section>
    </Link>
  );
};

TopRefsItem.propTypes = {
  data: shape({
    directArticle: shape({
      articleId: number.isRequired,
      articleAddName: string,
      articleName: string.isRequired,
      articleNo: string.isRequired,
    }).isRequired,
  }).isRequired,
};

TopRefsItem.defaultProps = {
  data: {
    directArticle: {
      articleAddName: null,
    },
  },
};

export default withCountryContext(TopRefsItem);



// WEBPACK FOOTER //
// ./src/components/TopRefsItem/TopRefsItem.js